export default "__VITE_ASSET__wg1G4Kw8__"